import React from "react";
import {
  MainHeading,
  SubHeading,
  HowItWorksList,
  ListItem,
  StepNumber,
  ListItemText
} from "./styles";
import FastagBanner from "/public/images/Fastag.svg";
import { useSelector } from "react-redux";

interface HowItWorksItem {
  text: string;
  isVisible: boolean;
}

interface FastagInfoProps {
  heading: string;
  subHeading: string;
  howItWorks: HowItWorksItem[];
}

const FastagInfo: React.FC<FastagInfoProps> = ({
  heading,
  subHeading,
  howItWorks
}) => {
  const fastagAmount = useSelector(
    (state: any) =>
      state?.configuration?.normalisedConfig?.plans_container?.props
        ?.fastagAmount
  );
  return (
    <div>
      <FastagBanner style={{ marginBottom: "30px" }} />
      <MainHeading>
        {heading}
        {fastagAmount ? `${fastagAmount} recharge` : ""}
      </MainHeading>

      <SubHeading>{subHeading}</SubHeading>
      <HowItWorksList>
        {howItWorks
          .filter((item) => item.isVisible)
          .map((item, index) => (
            <ListItem key={index}>
              <StepNumber>{index + 1}</StepNumber>
              <ListItemText>{item.text}</ListItemText>
            </ListItem>
          ))}
      </HowItWorksList>
    </div>
  );
};

export default FastagInfo;
